export default __webpack_public_path__ + "static/color-emphasis-levels-text-light-a77e4a50873b82cfbee40792f7c575ca.png";